<template>
  <div>
    <h3>{{promoTitle}}</h3>
    <el-form
      ref="form"
      label-width="120px"
    >
      <div class="interface-settings">
        <h2>Interface settings</h2>
        <div class="ui-row"><span>Square header image</span>
          <el-switch v-model="squareHeader" />
        </div>
        <div class="ui-row"><span>Square lifestyle/product image</span>
          <el-switch v-model="squareSecondary" />
        </div>
        <div class="ui-row"><span>No purchase options available</span>
          <el-switch v-model="noPurchaseOptions" />
        </div>
      </div>

      <div class="container-add">
        <div class="col-left">
          <h2>Models</h2>
          <el-card
            class="box-card"
            v-for="(model, index) in models"
            :key="`input-${index}`"
          >
            <div
              slot="header"
              class="header_item clearfix"
              @click="toggleRowModels(index)"
            >
              <span class="title">{{model.sku}}</span>
              <el-button
                style="float: right; margin-top: 14px;"
                button
                type="danger"
                @click="deleteRowModels(index)"
                icon="el-icon-delete"
                circle
              ></el-button>
            </div>
            <div v-if="model.show">
              <ul>
                <li>
                  <el-form-item label="SKU">
                    <el-input
                      placeholder="SKU"
                      v-model="model.sku"
                    >{{model.sku}}</el-input>
                  </el-form-item>
                  <el-form-item label="Aan / Uit">
                    <el-switch
                      v-model="model.active"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                    >
                    </el-switch>
                  </el-form-item>
                  <el-form-item size="large">
                    <el-button
                      type="primary"
                      @click="toggleRowModels(index)"
                    >Opslaan</el-button>
                    <el-button @click="deleteRowModels(index)">Cancel</el-button>
                  </el-form-item>
                </li>
              </ul>
            </div>
          </el-card>
          <el-form-item>
            <el-button @click="addRowModels">Add new</el-button>
            <el-button @click="openBulk">Add Bulk</el-button>

          </el-form-item>

          <el-form-item size="large">
            <el-button
              type="primary"
              @click="onSubmit"
            >Opslaan</el-button>
            <el-button>
              <router-link :to="{ path: '/'}">Cancel</router-link>
            </el-button>
          </el-form-item>
        </div>
        <div class="col-right">
          <h2>Model list</h2>
          <el-card
            class="box-card"
            v-for="(input, index) in codes"
            :key="`input-${index}`"
          >
            <div
              slot="header"
              class="header_item clearfix"
              @click="toggleRowCodes(index)"
            >
              <span class="title">{{ input.title }}</span>
              <el-button
                style="float: right; margin-top: 14px;"
                button
                type="danger"
                @click="deleteRowCodes(index)"
                icon="el-icon-delete"
                circle
              ></el-button>
            </div>
            <div v-if="input.show">
              <ul>
                <li>
                  <el-form-item label="Titel">
                    <el-input
                      placeholder="Titel"
                      v-model="input.title"
                    > - {{ input.title }}</el-input>
                  </el-form-item>
                  <el-form-item label="Codes">
                    <el-input
                      type="textarea"
                      placeholder="codes.."
                      rows="10"
                      v-model="input.text"
                    > - {{ input.text }}</el-input>
                  </el-form-item>
                  <el-form-item size="large">
                    <el-button
                      type="primary"
                      @click="toggleRowCodes(index)"
                    >Opslaan</el-button>
                    <el-button @click="deleteRowCodes(index)">Cancel</el-button>
                  </el-form-item>
                </li>
              </ul>
            </div>
          </el-card>
          <el-form-item>
            <el-button @click="addRowCodes">Add new</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <el-dialog
      title="Bulk toevoegen"
      :visible.sync="addBulk"
      width="50%"
      :before-close="handleClose"
    >
      <el-form>
        <p>Add on every line a new model.</p>
        <el-form-item label="Modelcodes">
          <el-input
            type="textarea"
            v-model="bulk"
            :rows="10"
          ></el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button
            type="primary"
            @click="addBulkModels"
          >Add</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>



<script>
const fb = require("../firebase-config.js");
import axios from "axios";
import { db, promotionsCollection } from "../firebase-config.js";
import bulkPopup from "../components/popups/Bulk-popup.vue";

export default {
  data: function() {
    return {
      path: this.$route.path,
      promotionId: null,
      promoTitle: "",
      input: null,
      models: [],
      codes: [],
      promotionRecordId: null,
      promotionsData: [],
      addBulk: false,
      bulk: [],
      loading: false,
      squareSecondary: false,
      squareHeader: false,
      noPurchaseOptions: false
    };
  },
  mounted() {
    this.promotionId = this.$route.params.id;
    this.models = [];
    console.log(this.$route.params.id);

    // recieve items in document
    promotionsCollection.onSnapshot(promotionRef => {
      promotionsCollection
        .where("promotionId", "==", this.promotionId)
        .get()

        .then(querySnapshot => {
          console.log(querySnapshot, "querySnapshot");
          if (querySnapshot.docs.length === 1) {
            querySnapshot.forEach(doc => {
              this.promotionRecordId = doc.id;
              this.models = doc.data().models;
              this.codes = doc.data().codes;
              this.squareHeader = doc.data().squareHeader || false;
              this.squareSecondary = doc.data().squareSecondary || false;
              this.noPurchaseOptions = doc.data().noPurchaseOptions || false;
            });
          } else {
            console.log("doesnt exist");
            let promotionId = this.promotionId;
            let models = [];
            let codes = [];
            let active = true;
            let squareHeader = false;
            let squareSecondary = false;
            let noPurchaseOptions = false;
            const createdAt = new Date();

            promotionsCollection
              .add({
                promotionId,
                models,
                codes,
                active,
                createdAt,
                squareHeader,
                squareSecondary,
                noPurchaseOptions
              })
              .then(function(docRef) {
                console.log("Document written with ID: ", docRef.id);
                this.promotionRecordId = docRef.id;
              })
              .catch(function(error) {
                console.error("Error adding document: ", error);
              });
          }
        });
    });

    axios
      .get(
        `https://sebnapi.nl/promo/${
          this.$store.state.$lang
        }/cached/promotions/${this.promotionId}.json`
      )
      .then(data => {
        const promoDataContents = data.data.GetPromotionDetailsResult.Contents;
        this.promoTitle = this.getContent(
          promoDataContents,
          "Text",
          "Value",
          "Title"
        );
      });
  },
  methods: {
    openBulk() {
      this.addBulk = true;
    },
    addBulkModels() {
      let bulk = this.bulk;
      let lines = bulk.split(/\n/);
      let output = [];
      let outputText = [];
      for (var i = 0; i < lines.length; i++) {
        if (/\S/.test(lines[i])) {
          this.models.push({
            show: true,
            active: true,
            sku: lines[i]
          });
        }
      }

      this.addBulk = false;
    },
    handleClose(done) {
      this.$confirm("Weet je zeker dat je dit wilt cancelen?")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    addRowModels(index) {
      this.models.push({
        show: true,
        active: true,
        sku: null
      });
    },
    addRowCodes(index) {
      this.codes.push({
        show: true
      });
    },
    deleteRowModels(index) {
      this.models.splice(index, 1);
    },
    deleteRowCodes(index) {
      this.codes.splice(index, 1);
    },
    toggleRowModels(index) {
      this.models[index].show = !this.models[index].show;

      if (this.models[index].active === undefined) {
        this.models[index].active = true;
      }
    },
    toggleRowCodes(index) {
      this.codes[index].show = !this.codes[index].show;
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    toggleActief() {
      this.newUpdate.actief = !this.newUpdate.actief;
    },
    success_message() {
      this.$notify({
        title: "Success",
        message: "Succesvol toegevoegd.",
        type: "success"
      });
    },
    error_message() {
      this.$notify.error({
        title: "Error",
        message: "Er is iets mis gegaan."
      });
    },
    getProductName(sku) {
      let productName = "";
      axios
        .get(
          `https://api.samsung.com/model?key=D836F2310FDB43309FD65C433D5F8DE8&modelCode=${sku}&type=json&iaType=consumer&siteCode=nl`
        )
        .then(data => {
          const resultData = data.data.response.resultData;
          if (data.data.response.resultData !== "no data found") {
            return "Bestaat niet";
          } else {
            console.log("test");
            return data.data.response.resultData.Products.Product.BasicInfo[0]
              .DisplayName;
            console.log(
              data.data.response.resultData.Products.Product.BasicInfo[0]
                .DisplayName
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getContent: function(data, row, value, field) {
      const contentData = data.filter(function(item) {
        return item.Text === field;
      });

      return contentData[0].Value;
    },
    onSubmit() {
      console.log(this.promotionRecordId);
      const createdAt = new Date();
      let promotionId = this.promotionId;
      let promotionRecordId = this.promotionRecordId;
      let lang = this.$store.state.$lang;
      let actief = this.actief;
      let models = this.models;
      let codes = this.codes;
      let active = true;
      let path = this.$route.path;
      let squareSecondary = this.squareSecondary;
      let squareHeader = this.squareHeader;
      let noPurchaseOptions = this.noPurchaseOptions;

      console.log("update");
      console.log(promotionRecordId);

      promotionsCollection
        .doc(promotionRecordId)
        .set(
          {
            promotionId,
            lang,
            models,
            codes,
            active,
            createdAt,
            squareSecondary,
            squareHeader,
            noPurchaseOptions
          },
          { merge: true }
        )
        .then(function(docRef) {
          console.log("Document written with ID: ", promotionRecordId);

          /*
          models.forEach((item) => {
            let sku = item.sku
            let active = true

            promotionsCollection.doc(promotionRecordId).collection("models").add({
              sku,
              active,
            })
          });

          codes.forEach((item) => {
            let title = item.title
            let text = item.text
            let active = true

            promotionsCollection.doc(promotionRecordId).collection("codes").add({
              title,
              text,
              active
            })
          });
          */
        })
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
      this.success_message();
    }
  }
};
</script>

<style>
h3 {
  margin-bottom: 40px;
}
ul,
li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
li {
  padding: 40px;
}

.container-add {
  display: flex;
  flex-flow: row wrap;
}

.col-left {
  flex: 1 1 auto;
  margin-right: 20px;
}

.col-right {
  height: 100%;
  flex: 1 1 auto;
  margin-left: 20px;
  padding-bottom: 40px;
}

.el-card__body {
  padding: 0;
}

.el-card__header {
  padding: 2px 10px 14px;
}

.box-card {
  margin-bottom: 10px;
}

.header_item {
  cursor: pointer;
  line-height: 1.8;
}
.title {
  font-size: 20px;
  margin-top: 14px;
  padding-left: 20px;
  float: left;
}
.image_thumbnail {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 0;
  float: left;
  background-size: cover;
}

.image_thumbnail {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 0;
  float: left;
  background-size: cover;
}

.interface-settings {
}

.ui-row {
  margin-bottom: 1em;
  display: flex;
  justify-content: space-between;
  width: 340px;
}

.ui-row span {
  display: block;
}
</style>



// WEBPACK FOOTER //
// Add.vue?75338009